module.exports = __webpack_public_path__ + "static/media/setting-transparent.0810175f.svg";